import {
  init,
  type InitResult,
  type SDKOptions,
} from '@airwallex/components-sdk'

import { AIRWALLEX_CONFIG } from './constants'
import { BankingUseCaseErrors } from '../BankingUseCaseErrors'

export class InitializeAirwallexSdkUseCase {
  constructor(private deps: {}) {}

  execute = async ({
    authData,
    isProd,
    onInitialized = () => Promise.resolve(),
  }: {
    authData: { authCode: string | undefined; codeVerifier: string | undefined }
    isProd: boolean
    onInitialized?: (initResult: InitResult) => Promise<void>
  }) => {
    try {
      if (!authData?.authCode) return null

      const options: SDKOptions = {
        locale: AIRWALLEX_CONFIG.LOCALE,
        env: isProd ? AIRWALLEX_CONFIG.PROD_ENV : AIRWALLEX_CONFIG.DEV_ENV,
        enabledElements: ['risk', 'payouts'],
        clientId: isProd
          ? AIRWALLEX_CONFIG.PROD_CLIENT_ID
          : AIRWALLEX_CONFIG.DEV_CLIENT_ID,
        authCode: authData.authCode,
        codeVerifier: authData.codeVerifier,
      }
      const result = await init(options)

      await onInitialized(result)
      return result
    } catch (error) {
      throw new BankingUseCaseErrors({
        name: 'ERROR_INITIALIZING_AIRWALLEX',
        message: 'Failed to initialize Airwallex SDK',
      })
    }
  }
}
